import React from 'react';

import { UserInlinePreview, UserInlinePreviewList } from '@atlassian/user-inline-preview';

import type { Collaborator } from '../../types';

/** Matches product spec: at most eight collaborators, no expansion control. */
export const USER_PROFILE_PREVIEW_COLLABORATORS_MAX = 8;
export const USER_PROFILE_PREVIEW_COLLABORATORS_MAX_COMPACT = 3;

interface CollaboratorsProps {
	collaborators: Collaborator[];
	cloudId: string;
	orgId?: string;
	testId?: string;
	variant?: 'compact' | 'full';
}

export function Collaborators({
	collaborators,
	cloudId,
	orgId,
	testId = 'user-profile-preview-collaborators',
	variant = 'full',
}: CollaboratorsProps): React.JSX.Element {
	return (
		<UserInlinePreviewList
			layout={variant === 'compact' ? 'stack' : 'grid'}
			maxVisibleItems={
				variant === 'compact'
					? USER_PROFILE_PREVIEW_COLLABORATORS_MAX_COMPACT
					: USER_PROFILE_PREVIEW_COLLABORATORS_MAX
			}
			testId={testId}
		>
			{collaborators.map((person) => (
				<UserInlinePreview
					key={person.accountId}
					data={{
						accountId: person.accountId,
						name: person.name,
						avatarUrl: person.avatarUrl,
						jobTitle: person.jobTitle,
					}}
					cloudId={cloudId}
					orgId={orgId}
					showOrgChartButton={false}
					renderContext="collaborator"
				/>
			))}
		</UserInlinePreviewList>
	);
}
